import { SUPPORT_CENTER_ITEMS } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";
import { SupportCenterItem } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SupportCenter/SupportCenterItem";
import {
  popoutContainerCss,
  supportCenterUnorderedListCss,
  supportTitleCss,
  supportChatSectionCss,
  supportChatInfoTextCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/SupportCenter/SupportCenterPopout/SupportCenterPopout.styles";
import useGetUserProperties from "@/users/v3/useGetUserProperties";
import useUser from "@/users/v3/useGetUser";
import {
  useSalesforceChatSupport,
  SALESFORCE_CHAT_START,
  SALESFORCE_CHAT_END,
} from "@/salesforceChatSupport";
import { SupportCenterChatButton } from "../SupportCenterChatButton";

const SupportCenterPopout = () => {
  const { data: user } = useUser();
  const userProperties = useGetUserProperties();

  const { isChatReady, launchChat } = useSalesforceChatSupport();
  // isChatReady will be true if the current time is within support hours.
  // Hide chat button from students AND trial users
  // Wait for properties to load before showing button
  const shouldShowSupportChatButton =
    isChatReady &&
    !userProperties?.isLoadingFeatures &&
    !userProperties?.isStudent &&
    !userProperties?.isLiteUser;

  return (
    <div css={popoutContainerCss}>
      <div css={supportTitleCss}>Support</div>

      <ul css={supportCenterUnorderedListCss}>
        {SUPPORT_CENTER_ITEMS.filter((item) => {
          if (typeof item.enabled === "function") {
            // Only call function if we have a valid user
            return user ? item.enabled(user, userProperties) : false;
          }
          return item.enabled;
        }).map(({ title, href, openInNewTab, ItemIcon }, index) => (
          <SupportCenterItem
            title={title}
            href={href}
            ItemIcon={ItemIcon}
            openInNewTab={openInNewTab}
            key={index}
          />
        ))}
        {shouldShowSupportChatButton ? (
          <li css={supportChatSectionCss}>
            <SupportCenterChatButton launchChat={launchChat} />
            <span css={supportChatInfoTextCss}>
              Available from Monday to Friday - {SALESFORCE_CHAT_START}am to{" "}
              {SALESFORCE_CHAT_END - 12}pm EST
            </span>
          </li>
        ) : null}
      </ul>
    </div>
  );
};

SupportCenterPopout.displayName = "SupportCenterPopout";
export { SupportCenterPopout };
